import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import TimeUsageReportPage from './TimeUsageReportPage';
import { bindActionCreators, Dispatch } from 'redux';
import {
  loadTimeUsageReports,
  setChartVisibility,
  setFilterValues,
} from '../../redux/modules/reports/reportsCreators';
import * as orderActions from '../../redux/modules/order/orderActions';
import { loadRoutes } from '../../redux/modules/route/routeCreators';
import { getRoutes } from '../../redux/modules/route/routeSelectors';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    isLoading: state.reports.isLoading,
    timeUsageReportList: state.reports.timeUsageReports,
    allFractions: state.order.allFractions,
    routes: getRoutes(state),
    timeUsageReportFilter: state.reports.timeUsageReportFilter,
    isChartsVisible: state.reports.isChartsVisible,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    loadTimeUsageReports: bindActionCreators(loadTimeUsageReports, dispatch),
    orderActions: bindActionCreators(orderActions, dispatch),
    loadRoutes: bindActionCreators(loadRoutes, dispatch),
    setFilter: bindActionCreators(setFilterValues, dispatch),
    setChartVisibility: bindActionCreators(setChartVisibility, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimeUsageReportPage);
